import {useController, useFormContext} from 'react-hook-form'

import {useAddDestinationAction} from '../../../../../actions/AddDestination/useAddDestinationAction'
import {useRemovePointHandlers} from '../../../../../actions/RouteMap/components/RouteInfo/useRemovePointHandlers'
import {useRouteInfo} from '../../../../../actions/RouteMap/components/RouteInfo/useRouteInfo'
import {FieldName} from '../../../../../lib/fieldNames'
import type {Contact, Route} from '../../../../../types'

export function useAddressWidget(routePointIndex: number) {
  const triggerAddDestinationAction = useAddDestinationAction()
  const {watch} = useFormContext()
  const {addresses} = useRouteInfo({})
  const {
    field: {value: defaultRouteFieldValue, onChange: updateRoute},
  } = useController({name: FieldName.Route})
  const {
    field: {onChange: updateContacts},
  } = useController({name: FieldName.Contacts})

  function setAddresses(newAddresses) {
    let newRoute: Route = {}
    const newContacts: Contact[] = []
    newAddresses.forEach(({address, contacts}, index: number) => {
      const key = index === 0 ? 'source' : `destination_${index}`
      contacts.pointId = key
      newRoute[key] = {address}
      newContacts.push(contacts)
    })

    if (!defaultRouteFieldValue) return

    const prevRouteCopy = {...defaultRouteFieldValue}
    for (const key of Object.keys(prevRouteCopy)) {
      if (key.startsWith('destination_')) {
        delete prevRouteCopy[key]
      }
    }

    newRoute = {...prevRouteCopy, ...newRoute}
    updateRoute(newRoute)
    updateContacts(newContacts)
  }

  const removeHandlers = useRemovePointHandlers({
    addresses,
    setAddresses,
  })

  function handleRemoveAddress() {
    removeHandlers[routePointIndex]()
  }

  const route = watch('route')
  const destinationCount = route ? Object.keys(route).filter(key => key.startsWith('destination_')).length : 1

  return {
    triggerAddDestinationAction,
    handleRemoveAddress,
    destinationCount,
  }
}
